// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.accountview.properties.RentalManagerAccountViewZramMultifamilyWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  AccountViewListingAdvertisingDto,
  AccountViewListingOptionsDto,
  AccountViewListingProspectsDto,
  AccountViewListingQualityScoreDto,
  AccountViewListingsDto,
  AccountViewListingSourcesDto,
  AccountViewListingStatusOverviewDto,
  ListingAlias,
  RentalManagerListingFieldSortType,
} from '../..';

interface AdvertisingParams {
  bypassCache?: boolean;
  listingAlias: ListingAlias;
}
interface ListParams {
  ascending?: boolean;
  includeActive?: boolean;
  includeArchived?: boolean;
  includeAtRiskOnly?: boolean;
  includeFreeBonusListingsOnly?: boolean;
  includeFreeClaimedListingsOnly?: boolean;
  includeInactive?: boolean;
  includeListingCounts?: boolean;
  includeSpotlightedOnly?: boolean;
  includeUnarchived?: boolean;
  limit?: number;
  offset?: number;
  searchText?: string;
  sort?: RentalManagerListingFieldSortType;
  startKeyExclusive?: string;
}
interface ListingQualityScoreParams {
  listingAlias: ListingAlias;
}
interface OptionsParams {
  listingAlias: ListingAlias;
}
interface ProspectsParams {
  listingAlias: ListingAlias;
}
interface SourcesParams {
  listingAlias: ListingAlias;
}
interface StatusParams {
  listingAlias: ListingAlias;
}

export const RentalManagerAccountViewZramMultifamilyWebApiHandler_advertising_Path =
  '/api/web/v1/users/accountView/zram/multifamily/properties/advertising';

/**
 * Get multifamily customer account view property listing advertising
 */
export const RentalManagerAccountViewZramMultifamilyWebApiHandler_advertising = (
  getParams: AdvertisingParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<AdvertisingParams, never, AccountViewListingAdvertisingDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerAccountViewZramMultifamilyWebApiHandler_advertising_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerAccountViewZramMultifamilyWebApiHandler_list_Path =
  '/api/web/v1/users/accountView/zram/multifamily/properties/list';

/**
 * Get multifamily customer account view property list
 */
export const RentalManagerAccountViewZramMultifamilyWebApiHandler_list = (
  getParams: ListParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<ListParams, never, AccountViewListingsDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerAccountViewZramMultifamilyWebApiHandler_list_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerAccountViewZramMultifamilyWebApiHandler_listingQualityScore_Path =
  '/api/web/v1/users/accountView/zram/multifamily/properties/listingQualityScore';

/**
 * Get multifamily customer account view property listing quality score
 */
export const RentalManagerAccountViewZramMultifamilyWebApiHandler_listingQualityScore = (
  getParams: ListingQualityScoreParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<ListingQualityScoreParams, never, AccountViewListingQualityScoreDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerAccountViewZramMultifamilyWebApiHandler_listingQualityScore_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerAccountViewZramMultifamilyWebApiHandler_options_Path =
  '/api/web/v1/users/accountView/zram/multifamily/properties/options';

/**
 * Get multifamily customer account view property listing options
 */
export const RentalManagerAccountViewZramMultifamilyWebApiHandler_options = (
  getParams: OptionsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<OptionsParams, never, AccountViewListingOptionsDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerAccountViewZramMultifamilyWebApiHandler_options_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerAccountViewZramMultifamilyWebApiHandler_prospects_Path =
  '/api/web/v1/users/accountView/zram/multifamily/properties/prospects';

/**
 * Get multifamily customer account view property prospects
 */
export const RentalManagerAccountViewZramMultifamilyWebApiHandler_prospects = (
  getParams: ProspectsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<ProspectsParams, never, AccountViewListingProspectsDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerAccountViewZramMultifamilyWebApiHandler_prospects_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerAccountViewZramMultifamilyWebApiHandler_sources_Path =
  '/api/web/v1/users/accountView/zram/multifamily/properties/sources';

/**
 * Get multifamily customer account view property listing sources
 */
export const RentalManagerAccountViewZramMultifamilyWebApiHandler_sources = (
  getParams: SourcesParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<SourcesParams, never, AccountViewListingSourcesDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerAccountViewZramMultifamilyWebApiHandler_sources_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerAccountViewZramMultifamilyWebApiHandler_status_Path =
  '/api/web/v1/users/accountView/zram/multifamily/properties/status';

/**
 * Get multifamily customer account view property listing status
 */
export const RentalManagerAccountViewZramMultifamilyWebApiHandler_status = (
  getParams: StatusParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<StatusParams, never, AccountViewListingStatusOverviewDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerAccountViewZramMultifamilyWebApiHandler_status_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
